module.exports = __webpack_public_path__ + "static/media/Apple Watch 38mm Gold + Black Leather Closed.20702952.png";